import script from "./RfidGuestLinkBraceletPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RfidGuestLinkBraceletPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__